// Client lib imports
const airbrake = require('client/lib/airbrake')
const { FriendlyRequestError } = require('client/lib/request')
// Client V2 common imports
const clientV1Bridge = require('client-v2/common/client-v1-bridge')
const { processImageFinalCrop } = require('client-v2/common/containers/upload-image-modal/utils')

// Action types

const SHOW = 'COLLECTION_PROFILE_HEADER_IMAGE_MODAL_SHOW'
const HIDE = 'COLLECTION_PROFILE_HEADER_IMAGE_MODAL_HIDE'

// Action creators

function show(payload) {
  return {
    type: SHOW,
    payload
  }
}

function hide() {
  return {
    type: HIDE
  }
}

// Action dispatchers

function deleteImage() {
  return function (dispatch, getState) {
    const { headerImageModal } = getState()
    dispatch(hide())
    headerImageModal.onDelete()
  }
}

function dismiss() {
  return function (dispatch, getState) {
    const { headerImageModal } = getState()
    dispatch(hide())
    headerImageModal.onDismiss()
  }
}

function submitImage({ image, crop }) {
  return function (dispatch, getState) {
    const { headerImageModal } = getState()
    return processImageFinalCrop(image, crop)
    .then(file => {
      dispatch(hide())
      headerImageModal.onSubmit(file)
    })
    .catch(err => {
      let message = 'We could not process this image.'
      if (err instanceof FriendlyRequestError) {
        message = err.message
      } else {
        airbrake.notify(err)
      }
      clientV1Bridge.showAlertModal({
        heading: 'Sorry.',
        subheading: message
      })
    })
  }
}

module.exports = {
  // Action types
  HIDE,
  SHOW,
  // Action creators
  hide,
  show,
  // Action dispatchers
  deleteImage,
  dismiss,
  submitImage
}
